import api from "../api";

/**
 * Extend an existing order reservation time.
 *
 * @param {string} orderId - The ID of the order to extend.
 * @param {string} startTime - The new start time (ISO string).
 * @param {string} endTime - The new end time (ISO string).
 * @param {string} planId - The plan ID for the extension.
 * @param {string} storeSimulatorId - The simulator/venue ID.
 * @param {string} [storeDiscountCode] - Optional discount code.
 * @param {string} [appUserCouponId] - Optional user coupon ID.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const extendOrder = async (
    orderId,
    startTime,
    endTime,
    planId,
    storeSimulatorId,
    storeDiscountCode,
    appUserCouponId
) => {
    // Set seconds to 0
    const startDate = new Date(startTime);
    startDate.setSeconds(0, 0);
    const endDate = new Date(endTime);
    endDate.setSeconds(0, 0);

    const requestData = {
        startTime: startDate.toISOString(),
        endTime: endDate.toISOString(),
        planId: planId,
        status: "pending",
        storeSimulatorId: storeSimulatorId,
        ...(storeDiscountCode && { storeDiscountCode: storeDiscountCode }),
        ...(appUserCouponId && { appUserCouponId: appUserCouponId }),
    };

    try {
        console.log("[extendOrder] orderId:", orderId);
        console.log("[extendOrder] request:", requestData);
        const response = await api.post(
            process.env.REACT_APP_REACT_APP_CD_API_ENDPOINT +
            `/app/appointment/simulator/over-time/${orderId}/credit`,
            requestData
        );
        console.log("[extendOrder] response:", response.data);
        return response.data;
    } catch (error) {
        console.error("[extendOrder] error status:", error.response?.status);
        console.error("[extendOrder] error statusText:", error.response?.statusText);
        console.error("[extendOrder] error data:", error.response?.data);
        console.error("[extendOrder] error headers:", error.response?.headers);
        console.error("[extendOrder] full error:", error);
        throw error;
    }
};

export default extendOrder;
